import { render, staticRenderFns } from "./Playvideos.vue?vue&type=template&id=4c0b19f0"
import script from "./Playvideos.vue?vue&type=script&lang=js"
export * from "./Playvideos.vue?vue&type=script&lang=js"
import style0 from "./Playvideos.vue?vue&type=style&index=0&id=4c0b19f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports